import { Text, type TextProps } from '@/ui';

export const ConfirmDialogTitle = (props: TextProps) => {
  return <Text fontSize="lg" {...props} />;
};
